import { useEffect } from "react";
import { useQuill } from "react-quilljs";

interface RichTextPreviewProps {
  content: string;
}

const RichTextPreview = ({ content }: RichTextPreviewProps) => {
  const { quill, quillRef } = useQuill({
    theme: "bubble",
    readOnly: true,
  });

  useEffect(() => {
    if (quill) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      quill.setContents(JSON.parse(content));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quill]);

  return <div ref={quillRef} />;
};

export default RichTextPreview;
